/* eslint-disable react/require-default-props */
/* eslint-disable no-shadow */
import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const ImageContainer = styled.div`
  width: 128px;
  text-align: center;
`;

const Card = styled.div(
  ({ theme, cursor }) => css`
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    background-color: #fff;
    border-radius: 6px;
    height: 128px;
    ${(props) =>
      props.cursor &&
      css`
        cursor: pointer;
      `}
    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      display: none;
    }
  `
);

const HelpText = styled.div`
  height: 88px;
  border-left: 1px solid #e4e6eb;
  margin-left: 24px;
  margin: 20px 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 20px;
  h2 {
    margin: 0;
    margin-bottom: 8px;
    font-size: 20px;
    width: 100%;
  }
  p {
    margin: 0;
    font-size: 16px;
  }
`;

const CardMobile = styled.div(
  ({ theme }) => css`
    flex-direction: column;
    margin-bottom: 16px;
    padding: 24px;
    padding-bottom: 40px;
    align-items: center;
    background-color: #fff;
    border-radius: 6px;
    div {
      display: flex;
      justify-content: start;
    }

    h2 {
      display: flex;
      align-items: center;
      padding-left: 24px;
      height: 56px;
      vertical-align: middle;
      border-left: 1px solid #e4e6eb;
    }

    p {
      font-size: 14px;
      margin: 0;
      width: 264px;
      line-height: 20px;
    }
    display: none;
    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      display: flex;
    }
  `
);

const HelpCard = ({ text: { title, subtitle, img, path }, cssPointer, disabledNavigation }) => {
  const history = useHistory();
  return (
    <>
      <Card
        onClick={!disabledNavigation && cssPointer && (() => history.push(path))}
        cursor={cssPointer}
      >
        <ImageContainer>
          <img width={56} src={publicPath + img} alt={title} id={title} />
        </ImageContainer>
        <HelpText>
          <h2>{title}</h2>
          <span />
          <p>{subtitle}</p>
        </HelpText>
      </Card>
      <CardMobile onClick={!disabledNavigation && (() => history.push(path))}>
        <div>
          <ImageContainer>
            <img width={56} src={publicPath + img} alt={title} id={title} />
          </ImageContainer>
          <h2>{title}</h2>
        </div>
        <p>{subtitle}</p>
      </CardMobile>
    </>
  );
};

HelpCard.propTypes = {
  text: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    img: PropTypes.string,
    path: PropTypes.string,
  }),
};

export default HelpCard;
